import {Alert, Form} from "react-bootstrap";
import Datetime from "react-datetime";
import "react-datetime/css/react-datetime.css";
import PropTypes, {array, string} from "prop-types";
import {LabelFor} from "./LabelFor.jsx";
import moment from "moment";
import 'moment/dist/locale/pl';

const DateTimePicker = (props) => {
    let inputProps = {
        placeholder: '',
        disabled: props.disabled,
    };

    const handleOpen = () => {
        if (!props.value) {
            props.onChange(moment().set({ hour: 23, minute: 59 }).format(props.format || 'YYYY-MM-DD'))
        }
    }
    return (
        <div title={props.title}>
            <Form.Group readOnly={props.readOnly}
                        className={props.className}>
                <LabelFor label={props.label} id={'dt'}  tooltipText={props.tooltipText}/>
                <Datetime
                    inputProps={inputProps}
                    isValidDate={props.validDate}
                    onOpen={handleOpen}
                    dateFormat={props.dateFormat || 'YYYY-MM-DD'}
                    timeFormat={!props.hideTime}
                    initialViewDate={props.value}
                    onChange={e =>
                        props.onChange(!e ? null : moment(e?._d || '').format(props.format || 'YYYY-MM-DD'))
                    }
                    value={!props.value ? null : moment(props.value).format(props.format || 'YYYY-MM-DD') || ''}
                />
                {props.errorText && (
                    <Alert className={"p-1 w-100"} variant={"danger"}>
                        <div className={"ms-1"}> {props.errorText}</div>
                    </Alert>
                )}
            </Form.Group></div>
    );
};


DateTimePicker.propTypes = {
    hideTime: PropTypes.bool,
    onChange: PropTypes.func,
    value: PropTypes.any,
    label: PropTypes.string,
    errorText: PropTypes.oneOfType([string, array]),
    className: PropTypes.string,
    title: PropTypes.string,
    readOnly: PropTypes.bool,
    validDate: PropTypes.func,
    pastOnly: PropTypes.bool,
    futureOnly: PropTypes.bool,
    dateFormat: PropTypes.string,
    initialViewDate: PropTypes.any,
    disabled: PropTypes.bool,
    name: PropTypes.string,
    format: PropTypes.string,
    tooltipText: PropTypes.string,
};

export default DateTimePicker;
